import React, { useRef, useState } from "react";
import { Avatar, Button, Col, DatePicker, Drawer, Dropdown, Layout, Popover, Row, Select, Space, Spin, Typography } from "antd";
import RoundedButton from "src/components/Notifications/RoundedButton";
import { logout, ssoRevoke } from "src/services/authen.service";
import { useLocation, useNavigate } from "react-router-dom";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { getHeadMenus } from "src/utils/get-menus";
import { menuPalette } from "src/theme/menu-shade";
import { DownOutlined, MenuOutlined } from "@ant-design/icons";
import CustomMenu from "./CutomMenu";
import "./Css/Header.css";

const { Header } = Layout;
const { Title, Text } = Typography;
const title_txt = { color: menuPalette.titleText, fontWeight: "bold" };

export const Headers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openDrawer, setOpenDrawer] = useState(false);
  const clearProfile = profileStore(useShallow((state) => state.clearProfile));
  const profile = profileStore(useShallow((state) => state.profile));
  const company = profile?.company ?? [];
  const loading = profileStore(useShallow((state) => state.loading));
  const requestProfile = profileStore(useShallow((state) => state.requestProfile));
  // const setActiveCompany = profileStore(useShallow((state) => state.setCompanyIntoProfile));
  const onLogout = async () => {
    try {
      await logout();
      const resRevoke = await ssoRevoke();
      localStorage.clear();
      clearProfile();
      if (resRevoke.status === 200) {
        // Case : Logout from AD
        // const url: string = `${process.env.REACT_APP_BASE_URL_AUTHEN}/logout/SCGC/${process.env.REACT_APP_ID}`;
        // window.location.href = url;

        // Case : back to login
        window.location.href = `${process.env.REACT_APP_LOGIN_PAGE}/${process.env.REACT_APP_ID}`;
      } else {
        navigate("/login");
      }
    } catch (error) {
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_LOGIN_PAGE}/${process.env.REACT_APP_ID}`;
    }
  };
  const onSelectCompany = (selected: string) => {
    const findSlot = company?.find((item) => item._id == selected);
    if (findSlot) {
      // setActiveCompany(findSlot);
      requestProfile({ companyId: selected });
    }
  };

  const selectRef: any = useRef(null);

  const showDrawer = () => setOpenDrawer(true);
  const onClose = () => setOpenDrawer(false);
  const renderSelectCompanyDropdown = () => (
    <Select
      ref={selectRef}
      showAction={["focus"]}
      className="w-full border-transparent"
      value={profile?.activeCompany._id}
      onChange={onSelectCompany}
      loading={loading}
      suffixIcon={
        loading ? (
          <Spin spinning />
        ) : (
          <DownOutlined
            onClick={() => {
              selectRef.current?.focus();
              // const element: any = document.querySelector("#select-company-dd .ant-select-selector");
              // if (element) element?.click();
            }}
            style={{
              zIndex: 2,
              ...title_txt,
              fontSize: "1em",
              strokeWidth: "50", // --> higher value === more thickness the filled area
              stroke: title_txt.color,
            }}
          />
        )
      }
    >
      {company &&
        company.length > 0 &&
        company.map((item) => {
          return (
            <Select.Option key={item._id} value={item._id}>
              {item.companyName}
            </Select.Option>
          );
        })}
    </Select>
  );
  const renderProfileBox = () => {
    return (
      <>
        {profile?.name ? (
          <Avatar src={`${process.env.REACT_APP_DEFAULT_IMG_URL}${profile?.name}`} shape={"square"} size={"large"} />
        ) : (
          <Spin size={"small"} />
        )}
        {
          <Col className="pl-1">
            {profile?.name ? <Text style={{ ...title_txt, fontWeight: "bold" }}>{profile?.name}</Text> : <Spin size={"small"} />}
          </Col>
        }
      </>
    );
  };

  const renderLogoutBtn = () => (
    <Button size="small" className="w-full" onClick={onLogout} type="text">
      Logout
    </Button>
  );

  // console.log("Location : ", location);
  const isSettingMenu = location.pathname.includes("/setting");
  const isTargetMenu = location.pathname === "/target";
  const isReportMenu = location.pathname === "/report";
  const isProductionMenu = location.pathname === "/production";
  const isStatusMenu = location.pathname === "/status";

  return (
    <Header className="h-20 p-0 bg-transparent">
      <Row className="w-100 h-full">
        {/* MD or higher, normal screen */}
        <Col xs={{ span: 0 }} sm={{ span: 0 }} md={{ span: 24 }} className="h-5/6">
          <Row className="w-100 m-2 bg-white rounded-md">
            <Col flex={6}>
              <div className="pl-4 pt-4">
                <Title level={3} style={{ ...title_txt }}>
                  {getHeadMenus(location)}
                </Title>
              </div>
            </Col>
            <Col flex={1}>
              <Row>
                {!isSettingMenu && !isTargetMenu && !isReportMenu && !isProductionMenu && !isStatusMenu && (
                  <Col flex={1} className="" id={"select-company-dd"}>
                    {renderSelectCompanyDropdown()}
                  </Col>
                )}
                <Col flex={3}>
                  <Dropdown menu={{ items: [{ label: renderLogoutBtn(), key: "0" }] }} trigger={["click", "hover"]}>
                    <Row align={"middle"} className="ml-4" style={{ height: 50 }}>
                      {renderProfileBox()}
                    </Row>
                  </Dropdown>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        {/* SM or lower, small screen */}
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 0 }} className="w-100">
          <Row>
            <Col flex={1} className="">
              <Row className="w-full" justify={"space-between"} align={"middle"}>
                <Button onClick={showDrawer} className="flex items-center ml-2" type="primary">
                  <MenuOutlined />
                </Button>
                <Title level={3} style={title_txt} className="pt-2">
                  {getHeadMenus(location)}
                </Title>
                <div></div>
                <Drawer
                  title={
                    <Row className="w-full" justify={"space-between"} align={"middle"}>
                      <Text>{"VOC"}</Text>
                    </Row>
                  }
                  placement={"left"}
                  closable={false}
                  onClose={onClose}
                  open={openDrawer}
                >
                  <Col>
                    <Row>
                      {!isSettingMenu && (
                        <Col span={24} id={"select-company-dd"}>
                          {renderSelectCompanyDropdown()}
                        </Col>
                      )}
                      <Col span={24} className="pt-2">
                        <div className="flex flex-row justify-between items-center w-full">
                          <div className="flex flex-row justify-start items-center w-full h-full -ml-1">{renderProfileBox()}</div>
                          {renderLogoutBtn()}
                        </div>
                      </Col>
                    </Row>
                    <CustomMenu />
                  </Col>
                </Drawer>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Header>
  );
};
